import { render, staticRenderFns } from "./LessonMarks.vue?vue&type=template&id=06e47026&"
import script from "./LessonMarks.vue?vue&type=script&lang=js&"
export * from "./LessonMarks.vue?vue&type=script&lang=js&"
import style0 from "./LessonMarks.vue?vue&type=style&index=0&id=06e47026&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports